import { render, staticRenderFns } from "./Four.vue?vue&type=template&id=837ce882&"
import script from "./Four.vue?vue&type=script&lang=js&"
export * from "./Four.vue?vue&type=script&lang=js&"
import style0 from "./Four.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports